const CommonStorage = {
  state: {
    countryList: null
  },
  mutations: {
    SET_COUNTRY_LIST_MUTATION: (state, payload) => {
      state.countryList = payload
    }
  },
  actions: {
    SET_COUNTRY_LIST:({commit}, payload) => {
      commit('SET_COUNTRY_LIST_MUTATION', payload)
    }
  },
  getters: {
    get_country_list: (state) => {
      return state.countryList
    }
  }
}
export default CommonStorage
  